//Guide

/*
  imported breakLines() from blocking.js
*/

export function enableGuide(){
  return {type: 'ENABLE_GUIDE'}
}

export function disableGuide(){
  return {type: 'DISABLE_GUIDE'}
}



// WEBPACK FOOTER //
// ./src/actions/guide.js